import type { PerformanceMark } from "@fiverr-private/relay-sdk";
import RUMSpeedIndex from "rum-speedindex";

/**
 * Create a performanceMark like object with the calculated page speed index
 * @returns {object} A structure mimicking PerformanceMark, representing the speed index value
 */
export const speedIndexMark = (): PerformanceMark => ({
    counter: 1,
    entryType: "mark",
    name: "speed_index",
    startTime: RUMSpeedIndex(),
    _mergeable: true,
    duration: undefined,
    user_action: undefined,
    target: undefined,
    metrics: undefined,
});
